import moment from "moment";
import helper from "../../utils/helper";
const HistoryPoint = ({ key, historyPointData }) => {
  console.log('HistoryPoint historyPointData >>', historyPointData)
  const mapType = (type) => {
    const configType = {
      1: 'แนะนำเพื่อน บุคคลที่เรารัก',
      2: 'ปฏิบัติงานอย่างตั้งใจ',
      3: 'ปฏิบัติธรรมท่านโกเอ็นก้า',
      4: 'โบนัสพิเศษ! : แนะนำเพื่อน, ปฏิบัติงานอย่างตั้งใจ',
      5: 'โบนัสพิเศษ! : แนะนำเพื่อน, ปฏิบัติงานอย่างตั้งใจ, ปฏิบัติธรรมท่านโกเอ็นก้า',
    }
    if (configType[type]) {
      return configType[type]
    }
    return '-'
  }
  if (['1','2','3'].includes(`${historyPointData.type}`) ) {
    return (
      <li className="point-his-list" key={key}>
        <div className="point-his-box">
          <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
            <span style={{ fontSize: "10px" }}>{ mapType(historyPointData.type) }</span>
            { historyPointData.type == 3 && <span style={{ fontSize: "8px" }}>(อนุมัติเมื่อวันที่ {helper.FN.toDateFullThai(historyPointData.date)})</span> }
          </div>
          <div style={{ minWidth: "100px", textAlign: "right" }}>
            <svg
              style={{ marginRight: "10px" }}
              width="13"
              height="13"
              viewBox="0 0 13 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0 10.2908V11.375C0 12.2713 2.18359 13 4.875 13C7.56641 13 9.75 12.2713 9.75 11.375V10.2908C8.70137 11.0297 6.78437 11.375 4.875 11.375C2.96563 11.375 1.04863 11.0297 0 10.2908ZM8.125 3.25C10.8164 3.25 13 2.52129 13 1.625C13 0.728711 10.8164 0 8.125 0C5.43359 0 3.25 0.728711 3.25 1.625C3.25 2.52129 5.43359 3.25 8.125 3.25ZM0 7.62734V8.9375C0 9.83379 2.18359 10.5625 4.875 10.5625C7.56641 10.5625 9.75 9.83379 9.75 8.9375V7.62734C8.70137 8.49062 6.78184 8.9375 4.875 8.9375C2.96816 8.9375 1.04863 8.49062 0 7.62734ZM10.5625 7.90664C12.0174 7.6248 13 7.10176 13 6.5V5.41582C12.4109 5.83223 11.5451 6.1166 10.5625 6.2918V7.90664ZM4.875 4.0625C2.18359 4.0625 0 4.97148 0 6.09375C0 7.21602 2.18359 8.125 4.875 8.125C7.56641 8.125 9.75 7.21602 9.75 6.09375C9.75 4.97148 7.56641 4.0625 4.875 4.0625ZM10.4432 5.49199C11.9666 5.21777 13 4.67949 13 4.0625V2.97832C12.0986 3.61563 10.5498 3.9584 8.91973 4.03965C9.66875 4.40273 10.2197 4.89023 10.4432 5.49199Z"
                fill="#001F5C"
              />
            </svg>
            <span style={{ fontSize: "10px" }}>+ {historyPointData.amount} บาท</span>
            <div>
            </div>
          </div>
        </div>
      </li>
    )
  }

  if (['4','5'].includes(`${historyPointData.type}`) ) {
    return (
      <li className="point-his-list" key={key}>
        <div className="point-his-box">
          {/* { JSON.stringify(historyPointData) } */}
          <span style={{ fontSize: "10px" }}>{ mapType(historyPointData.type) }</span>
          <div style={{ minWidth: "100px", textAlign: "right" }}>
            <svg style={{ marginRight: "10px" }} width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M0 10.2908V11.375C0 12.2713 2.18359 13 4.875 13C7.56641 13 9.75 12.2713 9.75 11.375V10.2908C8.70137 11.0297 6.78437 11.375 4.875 11.375C2.96563 11.375 1.04863 11.0297 0 10.2908ZM8.125 3.25C10.8164 3.25 13 2.52129 13 1.625C13 0.728711 10.8164 0 8.125 0C5.43359 0 3.25 0.728711 3.25 1.625C3.25 2.52129 5.43359 3.25 8.125 3.25ZM0 7.62734V8.9375C0 9.83379 2.18359 10.5625 4.875 10.5625C7.56641 10.5625 9.75 9.83379 9.75 8.9375V7.62734C8.70137 8.49062 6.78184 8.9375 4.875 8.9375C2.96816 8.9375 1.04863 8.49062 0 7.62734ZM10.5625 7.90664C12.0174 7.6248 13 7.10176 13 6.5V5.41582C12.4109 5.83223 11.5451 6.1166 10.5625 6.2918V7.90664ZM4.875 4.0625C2.18359 4.0625 0 4.97148 0 6.09375C0 7.21602 2.18359 8.125 4.875 8.125C7.56641 8.125 9.75 7.21602 9.75 6.09375C9.75 4.97148 7.56641 4.0625 4.875 4.0625ZM10.4432 5.49199C11.9666 5.21777 13 4.67949 13 4.0625V2.97832C12.0986 3.61563 10.5498 3.9584 8.91973 4.03965C9.66875 4.40273 10.2197 4.89023 10.4432 5.49199Z"
                fill="#001F5C"
              />
            </svg>
            <span style={{ fontSize: "10px" }}>Bonus x {historyPointData.bonus}</span>
          </div>
        </div>
      </li>
    )
  }
  return <></>
};
export default HistoryPoint;
